// @flow
import React from "react";
import PageContainer from "../containers/PageContainer";
import CartsList from "../containers/CartList";
import CartDetails from "../containers/CartDetails";
import { useTranslation } from 'react-i18next';


export default function CartsView(props) {
    const { t } = useTranslation();
    const cartUrl = props.match.params.id;
  return (
      <PageContainer title={t("Carts")} showShopToolbar={false}>
          {cartUrl ? <CartDetails cartUrl={cartUrl} /> : <CartsList />}
    </PageContainer>
  );
}
